<template>
  <div
    class="empty"
    :style="`width:${width||'100%'};height:${height||(minHeight?'auto':'150px')};min-height:${minHeight||'auto'};${backgroundColor?`background-color:${backgroundColor}`:''}`"
  >{{text||'暂无数据'}}
  </div>
</template>
<style lang="scss" scoped>
  @import "empty.theme";

  .empty {
    background-color: #002456;
    color: $empty-color;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/empty/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/empty/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/empty/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-empty')
  export default {
    name: 'base-empty', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-empty': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>